import Api from '@/axios'

export default {
  getActivationDetails (id) {
    return Api().get(`facilities/${id}`)
  },
  addNewProfile (payload) {
    return Api().post('facilities', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
  },
  editProfile (id, payload) {
    return Api().post(`facilities/${id}`, payload)
  },
  changeProfileCanLogin (id, payload) {
    return Api().post(`can-login/${id}`, payload)
  },
  editProfileNote (id, payload) {
    return Api().post(`edit-notes/${id}`, payload)
  },
  loginAs (payload) {
    return Api().post('view-as', payload)
  },
  showFacilityAdmins (facilityId) {
    return Api().get(`facility/${facilityId}/admins`)
  },
  customSubscription (payload) {
    return Api().post('custom-subscription', payload)
  }

}
